
export const totalOptions = {
    chart: {
        height: 250,
        type: "line",
        stacked: false,
        toolbar: {
            show: false,
        },
    },
    dataLabels: {
        enabled: false
    },
    markers: {
        size: 4,
        shape: 'square'
    },
    colors: ["#bbb"],
    stroke: {
        width: 4,
        curve: "smooth",
    },
    theme: {
        mode: 'light'
    },
    xaxis: {
        labels: {
            show: false,
        }
    },
    yaxis: {
        axisTicks: {
            show: true,
        },
        axisBorder: {
            show: false,
        },
        labels: {
            style: {
                colors: "#000",
                fontSize: 13,
                fontWeight: 600,
                cssClass: 'apexcharts-yaxis-label'
            },
            padding: -5,
            formatter: function (value){
                return value != undefined ? value.toLocaleString() : value
            }
        },
        title: {
            text: "yaxis",
            style: {
                color: "#000",
            }
        }
    },
    tooltip: {
        shared: true,
        intersect: false,
        x: {
            show: true
        },
        theme: 'dark',
        marker: {
            show: true,
            fillColors: "#555",
        }
    },
    legend: {
        horizontalAlign: "center",
        fontSize: 12,
        fontWeight: 600,
        offsetX: 0,
        markers: {
            offsetX: 3
        },
    }
}

export const pspLabelVariant = {
    get(psp) {
        switch (psp) {
            case 'mellat':
                return '#b72f11';
            case 'novin':
                return '#9c27b0';
            case 'sepehr':
                return '#f387e4';
            case 'parsian':
                return '#8d6e63';
            case 'saman':
                return '#3f51b5';
            case 'pasargad':
                return '#f0c239';
            case 'asanpardakht':
                return '#009688';
            case 'irankish':
                return '#b91133';
        }
        return '#000'
    }
}

export const transactionStatusVariant = {
    get(status){
        switch (status) {
            case 'ناموفق':
                return '#fd0000'
            case 'موفق':
                return '#02a104'
        }
    }
}

// line chart used by the top-users report charts
export const topUsersLineOptions = (series, categories) => ({
    chart: {
        type: 'line',
        height: 420,
        fontFamily: 'iransans',
        toolbar: {
            show: false,
        },
        zoom: {
            enabled: false,
        },
    },
    series: series,
    xaxis: {
        categories: categories,
    },
    yaxis: {
        min: 0,
        labels: {
            formatter: function (value) {
                return value != undefined ? Number(value).toLocaleString() : value
            }
        },
    },
    stroke: {
        width: 2,
        curve: 'smooth',
    },
    markers: {
        size: 0,
        hover: {
            size: 4,
        },
    },
    colors: ['#4a50d6', '#0e9488', '#e09a1b', '#d6365c', '#2f7fd8', '#8b5cf6', '#16a34a', '#db2777', '#0891b2', '#a16207'],
    legend: {
        position: 'bottom',
        fontSize: '12px',
    },
    tooltip: {
        shared: true,
        intersect: false,
    },
    grid: {
        strokeDashArray: 4,
    },
    dataLabels: {
        enabled: false,
    },
})
